// Shell del ERP ÚNICO, con la FORMA de Random (familiar) y la UX de MADECI:
//   · arriba, el menú funcional HORIZONTAL (Stock, Compras, Ventas, Pago de Clientes, Pago a
//     Proveedores, Operaciones, DTE, Informes, Configuración) con sus menús desplegables, y una barra
//     pequeña de accesos rápidos configurable;
//   · al centro, un área grande y TRANQUILA cuando no se hace nada (logo, pendientes, recientes) y
//     DENSA cuando se trabaja;
//   · abajo, la barra de estado (empresa, bodega, usuario, VALIDACIÓN, conexión).
// MENÚ ≠ VENTANA: abrir un menú solo muestra opciones; una CONSULTA se muestra en el área central sin
// crear pestañas; una OPERACIÓN (Punto de Venta, Nota de Venta, Nueva OD) o un OBJETO (NV 10542, un
// cliente, un producto) abre su pestaña de trabajo. Abrir de nuevo el mismo objeto enfoca su pestaña.
// Las consultas visitadas y las pestañas quedan MONTADAS: volver a ellas no pierde filtros ni lo
// digitado. Cambiar de empresa cierra todo. Lo que está al frente deja su ruta en la barra del
// navegador (#/ventas/notas, #/ventas/notas/<id>), y una ruta pegada la abre.
// Navegar: cambiar la vista de navegación (no crea pestañas); también por contexto.
import { NavegarContexto, type Navegar } from './navegar';
import { ConsultaVales } from '../ventas/ValeVenta';
import { PublicacionDte } from '../dte/PublicacionDte';
import { PagoProveedor, type ModoPago } from '../tesoreria/PagoProveedor';
import { CuentasBancarias } from '../tesoreria/CuentasBancarias';
import { RegistroCompras } from '../compras/RegistroCompras';
import {
  AutorizacionesPago,
  CartolaProveedor,
  CxpResumen,
  HistorialPagos,
} from '../tesoreria/ConsultasPagos';
import { Cobro, type ModoCobro } from '../tesoreria/Cobro';
import { CartolaCliente, CxcResumen, Vencimientos } from '../tesoreria/ConsultasCobranza';
import { TeneduriaPagos } from '../tesoreria/TeneduriaPagos';
import { CartolaVendedor } from '../tesoreria/CartolaVendedor';
import {
  AprobacionesCompras,
  CostosCompra,
  DevolucionesCompra,
  FacturasCompra,
  HistorialCompras,
  NotasCompra,
  OrdenesCompra,
  ProveedoresCompras,
  Recepciones,
} from '../compras/ConsultasCompras';
import { FacturasRecibidas } from '../compras/Recibidos';
import {
  claveCompra,
  PestanaCompra,
  rutaCompra,
  TITULO_NUEVO,
  type DocCompra,
} from '../compras/PestanaCompra';
import { MaestrosLogistica } from '../logistica/MaestrosLogistica';
import { Reservas, Transferencias } from '../stock/TrasladosReservas';
import { AprobacionesVentas } from '../ventas/Aprobaciones';
import { FirmasSinPago } from '../ventas/FirmasSinPago';
import { DocumentosGuardados } from '../consultas/DocumentosGuardados';
import { EsperandoNc } from '../compras/EsperandoNc';
import { CostosLogisticos } from '../compras/CostosLogisticos';
import { DocumentosRandom } from '../consultas/DocumentosRandom';
import { Cotizacion, Cotizaciones } from '../ventas/Cotizacion';
import { CorreccionesVenta } from '../ventas/Correcciones';
import { NotaCreditoDirecta } from '../ventas/NotaCreditoDirecta';
import { Consignaciones } from '../ventas/Consignaciones';
import { DespachosVenta } from '../ventas/Despachos';
import { Pedidos } from '../ventas/Pedidos';
import { ImpresionMasiva } from '../ventas/ImpresionMasiva';
import { PanelNegocio } from '../gerencia/PanelNegocio';
import { Informes } from '../informes/Informes';
import { DocumentosDte, FoliosCaf, MonitorDte } from '../dte/PantallasDte';
import { PantallaConfig } from '../configuracion/PantallaConfig';
import { IncidenciasOd } from '../logistica/Incidencias';
import { OrdenesDespacho } from '../logistica/OrdenesDespacho';
import { InventarioFisico } from '../stock/InventarioFisico';
import { Valorizacion } from '../stock/Valorizacion';
import { AjustesStock } from '../stock/GuiaAjuste';
import { Kardex, Movimientos, StockPorBodega } from '../stock/PantallasStock';
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useReducer,
  useState,
  type Dispatch,
  type ReactNode,
} from 'react';
import type { ClienteEncontrado } from '../api/contratos';
import { MiTurno } from '../caja/MiTurno';
import { TurnosCaja } from '../caja/TurnosCaja';
import { ExcepcionesCierre } from '../caja/ExcepcionesCierre';
import { OperadoresCaja } from '../caja/OperadoresCaja';
import { BandejaSolicitudes } from '../clientes/BandejaSolicitudes';
import { CarteraCheques } from '../tesoreria/CarteraCheques';
import { RecepcionRutas } from '../tesoreria/RecepcionRutas';
import { RendicionOdd } from '../tesoreria/RendicionOdd';
import { CobrosRuta } from '../tesoreria/CobrosRuta';
import { CajaTesoreria } from '../tesoreria/CajaTesoreria';
import { ConsultaClientes } from '../clientes/ConsultaClientes';
import { ContextoCliente } from '../clientes/ContextoCliente';
import { Modal } from '../comun/Modal';
import { ConsultaDocumentos } from '../consultas/ConsultaDocumentos';
import { CentroOperativo } from '../inicio/CentroOperativo';
import { Despacho } from '../logistica/Despacho';
import { OrdenDespacho } from '../logistica/OrdenDespacho';
import { DocumentosEmitidos } from '../consultas/DocumentosEmitidos';
import { FichaDte } from '../dte/FichaDte';
import { ProveedorAbrirDte } from '../dte/DocumentosNota';
import { tituloDte } from '../dte/pdfDte';
import { ConsultaProductos } from '../productos/ConsultaProductos';
import { TratamientoListas } from '../precios/TratamientoListas';
import { FichaProducto } from '../productos/FichaProducto';
import { useSesion } from '../sesion/SesionContexto';
import { NotaVenta } from '../ventas/NotaVenta';
import { ATAJOS, useAtajos } from './atajos';
import { BarraHerramientas } from './BarraHerramientas';
import { BarraEstado } from './BarraEstado';
import { BuscadorGlobal, type ResultadoGlobal } from './BuscadorGlobal';
import { FirmasPendientes } from './FirmasPendientes';
import { MapaErp } from './MapaErp';
import { MenuPrincipal } from './MenuPrincipal';
import { AvisoConexion, MenuUsuario } from './MenuUsuario';
import { MODULOS, pantallaPorRuta, type Pantalla } from './navegacion';
import { Icono } from '../comun/Icono';
import { PantallaPreparada } from './PantallaPreparada';
import {
  estadoInicial,
  reducirPestanas,
  type AccionPestanas,
  type EstadoPestanas,
  type Pestana,
  type TipoPestana,
} from './pestanas';
import { useFavoritos, useNombresCortos, useRecientes, type Reciente } from './preferencias';
import { esPreproduccion, useModoRevision, useSalud, type Salud } from './salud';
import { urlSimulacion } from '../comun/Estados';

const CtxPestanas = createContext<{
  estado: EstadoPestanas;
  despachar: Dispatch<AccionPestanas>;
} | null>(null);

export function ProveedorPestanas({
  children,
}: {
  children: (reiniciar: () => void) => ReactNode;
}) {
  const [estado, despachar] = useReducer(reducirPestanas, estadoInicial);
  const reiniciar = useCallback(() => despachar({ tipo: 'reiniciar' }), []);
  return (
    <CtxPestanas.Provider value={{ estado, despachar }}>{children(reiniciar)}</CtxPestanas.Provider>
  );
}

function usePestanas() {
  const c = useContext(CtxPestanas);
  if (!c) throw new Error('usePestanas fuera de ProveedorPestanas');
  return c;
}

/** Abrir un OBJETO o proceso en su pestaña. */
type Abrir = (tipo: TipoPestana, params?: Record<string, string>, titulo?: string) => void;

/** Una vista de navegación montada: ruta del mapa + filtros con que se abrió. */
interface Vista {
  clave: string;
  ruta: string;
  params: Record<string, string>;
}
const claveVista = (ruta: string, params: Record<string, string>) => {
  const q = new URLSearchParams(params).toString();
  return q ? `${ruta}?${q}` : ruta;
};
const INICIO: Vista = { clave: 'inicio', ruta: 'inicio', params: {} };
/** Vistas que se mantienen montadas (las más recientes); el Inicio siempre. */
const MAX_VISTAS = 12;
const CLAVE_SUBSISTEMA = 'madeci.subsistema';

/** El módulo al que pertenece una pestaña (se subraya en el menú). */
const MODULO_DE_PESTANA: Record<TipoPestana, string> = {
  nota: 'ventas',
  contexto: 'ventas',
  cliente: 'ventas',
  despacho: 'operaciones',
  producto: 'stock',
  od: 'operaciones',
  cobro: 'cobros',
  pago: 'pagos',
  compra: 'compras',
  cotizacion: 'ventas',
  dte: 'ventas',
};

/**
 * VALIDACIÓN OPERACIONAL (docs/frontend/16): base real MADECI, Random sigue siendo el oficial. Fija,
 * arriba de todo, para que nadie confunda esta instancia con la operación real.
 */
function FranjaValidacion({ salud }: { salud: Salud | undefined }) {
  const fecha = (v: string | null | undefined, conHora = false) =>
    v
      ? new Date(v).toLocaleString('es-CL', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          ...(conHora ? { hour: '2-digit', minute: '2-digit' } : {}),
        })
      : null;
  const uat = salud?.modoOperacion === 'UAT';
  const preproduccion = esPreproduccion(salud);
  const foto = fecha(salud?.stockAl, true);
  const precios = fecha(salud?.preciosAl);
  const clientes = fecha(salud?.clientesAl);
  return (
    <div
      className={`franja-validacion${uat ? ' uat' : ''}`}
      role="note"
      aria-label={uat ? 'UAT integral' : preproduccion ? 'Preproducción' : 'Validación operacional'}
    >
      {preproduccion ? (
        <>
          <b>PREPRODUCCIÓN · NO OFICIAL</b> · BASE REAL MADECI · el sistema anterior sigue siendo el
          oficial ·{' '}
          <a className="enlace-simulacion" href={urlSimulacion()} target="_blank" rel="noopener">
            Despacho y facturación: ir a la SIMULACIÓN →
          </a>
        </>
      ) : uat ? (
        <>
          <b>SIMULACIÓN</b> · COPIA DE LA BASE MADECI · nada de lo que hagas aquí es oficial ·
          facturas, boletas y guías SIMULADAS (folios de prueba, sin SII)
        </>
      ) : (
        <>
          <b>VALIDACIÓN OPERACIONAL</b> · BASE REAL MADECI · el sistema anterior sigue siendo el
          oficial
        </>
      )}
      <span className="foto-stock" data-stock-al={salud?.stockAl ?? ''}>
        {foto ? `Stock: foto heredada al ${foto}` : 'Stock: sin fecha de foto'}
        {' · '}
        {precios ? `Precios: cargados el ${precios}` : 'Precios: sin fecha'}
        {' · '}
        {clientes ? `Clientes: base del ${clientes}` : 'Clientes: sin fecha'}
        {' · sin sincronización'}
      </span>
    </div>
  );
}

function AyudaAtajos() {
  return (
    <table className="grilla compacta atajos" aria-label="Atajos de teclado">
      <thead>
        <tr>
          <th>Tecla</th>
          <th>Acción</th>
          <th>Dónde</th>
        </tr>
      </thead>
      <tbody>
        {ATAJOS.map((a) => (
          <tr key={a.tecla}>
            <td>
              <kbd>{a.tecla}</kbd>
            </td>
            <td>{a.descripcion}</td>
            <td className="apagado">{a.ambito}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

/** Documentos directos (como en Random): una NV con el documento ya elegido y su propio nombre. */
const TITULO_DIRECTO: Record<string, string> = {
  FACTURA: 'Factura directa',
  BOLETA: 'Boleta directa',
  GUIA: 'Guía directa',
};

/** La ruta de una pestaña: el objeto mismo (#/ventas/notas/<id>, #/clientes/<id>…). */
function rutaDePestana(p: Pestana): string {
  switch (p.tipo) {
    case 'nota':
      return p.params['notaId']
        ? p.params['modo'] === 'meson'
          ? `ventas/punto-de-venta/${p.params['notaId']}`
          : `ventas/notas/${p.params['notaId']}`
        : p.params['modo'] === 'meson'
          ? 'ventas/punto-de-venta'
          : p.params['directo']
            ? `ventas/${({ FACTURA: 'factura', BOLETA: 'boleta', GUIA: 'guia' } as Record<string, string>)[p.params['directo']] ?? 'factura'}-directa`
            : 'ventas/nota-nueva';
    case 'contexto':
    case 'cliente':
      return `clientes/${p.params['entidadId']}`;
    case 'producto':
      return `stock/producto/${p.params['productoId']}`;
    case 'despacho':
      return `operaciones/despacho/${p.params['notaId']}`;
    case 'od':
      return p.params['odId'] ? `operaciones/od/${p.params['odId']}` : 'operaciones/od-nueva';
    case 'cobro':
      return `cobros/${RUTA_DE_COBRO[p.params['modo'] ?? 'factura'] ?? 'cobrar-factura'}`;
    case 'pago':
      return `pagos/${RUTA_DE_PAGO[p.params['modo'] ?? 'factura'] ?? 'pagar-factura'}`;
    case 'compra':
      return rutaCompra(p.params);
    case 'cotizacion':
      return p.params['cotizacionId']
        ? `ventas/cotizacion/${p.params['cotizacionId']}`
        : 'ventas/cotizacion-nueva';
    case 'dte':
      return `ventas/documento/${p.params['documentoId']}`;
  }
}

// Cobrar factura, a documento, a estado de cuenta y rápido son una sola pantalla (2026-10-16).
const RUTA_DE_COBRO: Record<string, string> = {
  factura: 'cobrar-factura',
  documentos: 'cobrar-factura',
  'estado-cuenta': 'cobrar-factura',
  rapido: 'cobrar-factura',
  aplicacion: 'aplicacion',
  anticipo: 'anticipos',
};
const TITULO_DE_COBRO: Record<string, string> = {
  factura: 'Cobrar',
  documentos: 'Cobrar',
  'estado-cuenta': 'Cobrar',
  rapido: 'Cobrar',
  aplicacion: 'Aplicación de pagos',
  anticipo: 'Anticipo',
};

const RUTA_DE_PAGO: Record<string, string> = {
  factura: 'pagar-factura',
  documentos: 'pagar-factura',
  'estado-cuenta': 'pagar-factura',
  masivo: 'pago-masivo',
  anticipo: 'anticipos',
};
const TITULO_DE_PAGO: Record<string, string> = {
  factura: 'Pagar',
  documentos: 'Pagar',
  'estado-cuenta': 'Pagar',
  masivo: 'Pago masivo',
  anticipo: 'Anticipo a proveedor',
};

const RE_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function Shell() {
  const sesion = useSesion();
  const { estado, despachar } = usePestanas();
  const [ayuda, setAyuda] = useState(false);
  const [buscar, setBuscar] = useState(false);
  const [cerrando, setCerrando] = useState<Pestana | null>(null);
  const [cambioEmpresa, setCambioEmpresa] = useState<string | null>(null);
  const [nombresCortos] = useNombresCortos();
  const activa = estado.pestanas.find((p) => p.id === estado.activa) ?? null;
  const haySucias = estado.pestanas.some((p) => p.sucia);

  const modoRevision = useModoRevision();
  // RBAC: una pantalla se ve solo con su permiso; un módulo, si tiene al menos una pantalla visible.
  const modulos = useMemo(
    () =>
      MODULOS.map((m) => ({
        ...m,
        secciones: m.secciones
          .map((s) => ({
            ...s,
            pantallas: s.pantallas.filter(
              (p) =>
                (!p.permiso || sesion.puede(p.permiso)) &&
                // El mapa del ERP es para revisar: no existe en producción.
                (p.ruta !== 'configuracion/mapa' || modoRevision),
            ),
          }))
          .filter((s) => s.pantallas.length),
      })).filter((m) => m.secciones.length),
    [sesion, modoRevision],
  );

  // ------------------------------------------------ vista de navegación
  const [vistas, setVistas] = useState<Vista[]>([INICIO]);
  const [vistaActual, setVistaActual] = useState('inicio');
  const vista = vistas.find((v) => v.clave === vistaActual) ?? INICIO;
  // Otra empresa: las vistas montadas eran de la anterior.
  const empresaId = sesion.empresa?.id;
  useEffect(() => {
    setVistas([INICIO]);
    setVistaActual('inicio');
  }, [empresaId]);

  const navegar: Navegar = useCallback(
    (ruta, params = {}) => {
      const clave = claveVista(ruta, params);
      setVistas((vs) => {
        const resto = vs.filter((v) => v.clave !== clave);
        const actual = vs.find((v) => v.clave === clave) ?? { clave, ruta, params };
        // La más reciente al final; se descartan las más antiguas (nunca el Inicio).
        const lista = [...resto, actual];
        while (lista.length > MAX_VISTAS) {
          const i = lista.findIndex((v) => v.clave !== 'inicio');
          lista.splice(i, 1);
        }
        return lista;
      });
      setVistaActual(clave);
      despachar({ tipo: 'navegar' });
    },
    [despachar],
  );

  const moduloActual = activa
    ? MODULO_DE_PESTANA[activa.tipo]
    : (pantallaPorRuta(vista.ruta)?.modulo.id ?? null);

  // ------------------------------------------------ subsistema (el ícono elegido, como en Random)
  // El menú de texto muestra los menús del subsistema elegido. Se recuerda entre sesiones y sigue a
  // lo que se abre: abrir una función o una pestaña de otro módulo cambia el subsistema a ese módulo.
  const [subsistema, setSubsistema] = useState<string>(() => {
    try {
      return localStorage.getItem(CLAVE_SUBSISTEMA) ?? 'ventas';
    } catch {
      return 'ventas';
    }
  });
  const elegirSubsistema = useCallback((id: string) => {
    setSubsistema(id);
    try {
      localStorage.setItem(CLAVE_SUBSISTEMA, id);
    } catch {
      /* sin almacenamiento: solo dura esta sesión */
    }
  }, []);
  useEffect(() => {
    if (moduloActual) elegirSubsistema(moduloActual);
  }, [moduloActual, elegirSubsistema]);
  const moduloSubsistema = modulos.find((m) => m.id === subsistema) ?? modulos[0] ?? null;

  // ------------------------------------------------ pestañas (objetos)
  const abrir: Abrir = useCallback(
    (tipo, params = {}, titulo) => {
      let clave: string;
      if (tipo === 'nota')
        clave = params['notaId'] ? `nota:${params['notaId']}` : `nota-nueva:${Date.now()}`;
      else if (tipo === 'cliente' || tipo === 'contexto') clave = `contexto:${params['entidadId']}`;
      else if (tipo === 'despacho') clave = `despacho:${params['notaId']}`;
      else if (tipo === 'od') clave = params['odId'] ? `od:${params['odId']}` : 'od:nueva';
      else if (tipo === 'cobro')
        clave = `cobro:${params['modo'] ?? 'factura'}:${params['clienteId'] ?? ''}`;
      else if (tipo === 'pago')
        clave = `pago:${params['modo'] ?? 'factura'}:${params['proveedorId'] ?? ''}`;
      else if (tipo === 'compra') clave = claveCompra(params);
      else if (tipo === 'cotizacion')
        clave = params['cotizacionId']
          ? `cot:${params['cotizacionId']}`
          : `cot-nueva:${Date.now()}`;
      else if (tipo === 'dte') clave = `dte:${params['documentoId']}`;
      else clave = `producto:${params['productoId']}`;
      despachar({
        tipo: 'abrir',
        pestana: {
          tipo,
          clave,
          params,
          titulo:
            titulo ??
            (tipo === 'nota'
              ? params['modo'] === 'meson'
                ? 'Punto de venta'
                : params['directo']
                  ? (TITULO_DIRECTO[params['directo']] ?? 'Nota nueva')
                  : 'Nota nueva'
              : tipo === 'producto'
                ? 'Producto'
                : tipo === 'od'
                  ? 'ODD nueva'
                  : tipo === 'cobro'
                    ? (TITULO_DE_COBRO[params['modo'] ?? 'factura'] ?? 'Cobro')
                    : tipo === 'pago'
                      ? (TITULO_DE_PAGO[params['modo'] ?? 'factura'] ?? 'Pago')
                      : tipo === 'compra'
                        ? TITULO_NUEVO[(params['doc'] ?? 'oc') as DocCompra]
                        : tipo === 'cotizacion'
                          ? 'Cotización nueva'
                          : tipo === 'dte'
                            ? 'Documento'
                            : 'Cliente'),
        },
      });
    },
    [despachar],
  );

  /** Una función del menú: las OPERACIONES abren su pestaña de trabajo; las consultas NAVEGAN. */
  const abrirPantalla = useCallback(
    (p: Pantalla, params: Record<string, string> = {}) => {
      if (p.abre?.tipo === 'nota') return abrir('nota', p.abre.params ?? {});
      if (p.abre?.tipo === 'od') return abrir('od');
      if (p.abre?.tipo === 'cobro') return abrir('cobro', p.abre.params ?? {});
      if (p.abre?.tipo === 'pago') return abrir('pago', p.abre.params ?? {});
      if (p.abre?.tipo === 'compra') return abrir('compra', p.abre.params ?? {});
      if (p.abre?.tipo === 'cotizacion') return abrir('cotizacion', p.abre.params ?? {});
      navegar(p.ruta, params);
    },
    [abrir, navegar],
  );
  const puedeVer = useCallback(
    (p: Pantalla) =>
      (!p.permiso || sesion.puede(p.permiso)) && (p.ruta !== 'configuracion/mapa' || modoRevision),
    [sesion, modoRevision],
  );
  const abrirRuta = useCallback(
    (ruta: string, params: Record<string, string> = {}) => {
      if (ruta === 'inicio') return navegar('inicio');
      const p = pantallaPorRuta(ruta);
      if (p && puedeVer(p)) abrirPantalla(p, params);
    },
    [abrirPantalla, navegar, puedeVer],
  );

  // Cualquier lista abre la ficha de un documento tributario (DocumentosNota).
  const abrirDteGlobal = useCallback(
    (documentoId: string, titulo: string) => abrir('dte', { documentoId }, titulo),
    [abrir],
  );
  const abrirContexto = useCallback(
    (c: Pick<ClienteEncontrado, 'id' | 'razon_social'>) =>
      abrir('contexto', { entidadId: c.id }, c.razon_social),
    [abrir],
  );
  const abrirProducto = useCallback(
    (p: { id: string; sku: string; nombre: string }) =>
      abrir('producto', { productoId: p.id }, `${p.sku} · ${p.nombre}`),
    [abrir],
  );

  const elegirResultado = (r: ResultadoGlobal) => {
    setBuscar(false);
    switch (r.tipo) {
      case 'pantalla':
        return abrirPantalla(r.pantalla);
      case 'cliente':
        return abrirContexto({ id: r.id, razon_social: r.razonSocial });
      case 'nota':
        return abrir('nota', { notaId: r.id }, r.numeroVisible);
      case 'producto':
        return abrirProducto({ id: r.id, sku: r.texto, nombre: r.nombre });
      // El documento tributario se abre en SU ficha (2026-10-26: «las que mandan son los DTE»).
      case 'dte':
        return abrir('dte', { documentoId: r.id }, tituloDte(r.tipoDte, r.folio));
      case 'proveedor':
        return navegar('compras/historial', { proveedorId: r.id, proveedor: r.razonSocial });
      case 'oc':
        return r.id ? abrir('compra', { doc: 'oc', id: r.id }) : abrirRuta('compras/ordenes');
      case 'od':
        return abrir('od', { odId: r.id }, `ODD ${r.numero}`);
      case 'pago':
        return abrirRuta('pagos/historial');
      case 'cotizacion':
        return abrir('cotizacion', { cotizacionId: r.id }, r.numeroVisible);
      case 'ruta':
        return abrirRuta('configuracion/rutas');
    }
  };

  // ------------------------------------------------ favoritos y recientes
  const usuarioId = sesion.usuario?.id;
  const { favoritos, alternar: alternarFavorito } = useFavoritos(usuarioId);
  const { anotar } = useRecientes(usuarioId, empresaId);
  useEffect(() => {
    if (!activa) return;
    const t = activa.titulo;
    if (activa.tipo === 'nota' && activa.params['notaId'] && t !== 'Nota')
      anotar({ tipo: 'nota', id: activa.params['notaId'], titulo: t });
    else if ((activa.tipo === 'contexto' || activa.tipo === 'cliente') && t !== 'Cliente')
      anotar({ tipo: 'cliente', id: activa.params['entidadId']!, titulo: t });
    else if (activa.tipo === 'producto' && t !== 'Producto')
      anotar({ tipo: 'producto', id: activa.params['productoId']!, titulo: t });
  }, [activa, anotar]);

  // ------------------------------------------------ rutas (#/...)
  const [rutaInicialLeida, setRutaInicialLeida] = useState(false);
  useEffect(() => {
    if (!sesion.permisosCargados || rutaInicialLeida) return;
    setRutaInicialLeida(true);
    const crudo = decodeURIComponent(window.location.hash.replace(/^#\/?/, ''));
    const [r = '', q = ''] = crudo.split('?');
    if (!r || r === 'inicio') return;
    const partes = r.split('/');
    const id = partes[partes.length - 1] ?? '';
    if (RE_UUID.test(id)) {
      const base = partes.slice(0, -1).join('/');
      if (base === 'ventas/notas') return abrir('nota', { notaId: id }, 'Nota');
      if (base === 'ventas/punto-de-venta')
        return abrir('nota', { notaId: id, modo: 'meson' }, 'Punto de venta');
      if (base === 'clientes' || base === 'ventas/clientes')
        return abrir('contexto', { entidadId: id }, 'Cliente');
      if (base === 'stock/producto') return abrir('producto', { productoId: id });
      if (base === 'operaciones/od') return abrir('od', { odId: id }, 'ODD');
      const doc = /^compras\/(oc|recepcion|factura|nota|devolucion|proveedor)$/.exec(base)?.[1];
      if (doc) return abrir('compra', { doc, id });
      if (base === 'ventas/cotizacion')
        return abrir('cotizacion', { cotizacionId: id }, 'Cotización');
      if (base === 'ventas/documento') return abrir('dte', { documentoId: id }, 'Documento');
    }
    abrirRuta(r, Object.fromEntries(new URLSearchParams(q)));
  }, [sesion.permisosCargados, rutaInicialLeida, abrir, abrirRuta]);
  useEffect(() => {
    if (!rutaInicialLeida) return;
    const r = activa ? rutaDePestana(activa) : vista.clave;
    if (window.location.hash !== `#/${r}`) window.history.replaceState(null, '', `#/${r}`);
  }, [activa, vista.clave, rutaInicialLeida]);

  const pedirCierre = (p: Pestana) =>
    p.sucia ? setCerrando(p) : despachar({ tipo: 'cerrar', id: p.id });

  const libre = !sesion.expirada && !ayuda && !cerrando && !cambioEmpresa && !buscar;
  useAtajos(libre, {
    F1: () => setAyuda(true),
    'Alt+N': () => {
      if (!sesion.puede('ventas.nota.crear')) return;
      // En la Ficha 360 de un cliente, Alt+N crea la nota PARA ese cliente.
      if (activa?.tipo === 'contexto' && activa.params['entidadId'])
        abrir('nota', { clienteId: activa.params['entidadId'] }, `Nota nueva · ${activa.titulo}`);
      else abrir('nota');
    },
    'Alt+O': () => abrirRuta('ventas/notas'),
    'Alt+Q': () => activa && pedirCierre(activa),
    'Ctrl+K': () => setBuscar(true),
    ...Object.fromEntries(
      Array.from({ length: 9 }, (_, i) => [
        `Alt+${i + 1}`,
        () => {
          const p = estado.pestanas[i];
          if (p) despachar({ tipo: 'activar', id: p.id });
        },
      ]),
    ),
  });

  // Recargar o cerrar el navegador con cambios sin guardar: el navegador pide confirmación.
  useEffect(() => {
    if (!haySucias) return;
    const avisar = (e: BeforeUnloadEvent) => e.preventDefault();
    window.addEventListener('beforeunload', avisar);
    return () => window.removeEventListener('beforeunload', avisar);
  }, [haySucias]);

  const salud = useSalud();
  // Validación operacional o UAT integral: una instancia que NO es la oficial se anuncia siempre.
  const modoInstancia = salud.data?.modoOperacion;
  const validacion = modoInstancia === 'VALIDACION_OPERACIONAL' || modoInstancia === 'UAT';

  const cambiarEmpresa = (id: string) =>
    haySucias ? setCambioEmpresa(id) : sesion.elegirEmpresa(id);

  const hayPestanas = estado.pestanas.length > 0;
  const pVista = pantallaPorRuta(vista.ruta);
  const nombreVista =
    vista.ruta === 'inicio' ? 'Inicio' : `${pVista?.modulo.nombre ?? ''} › ${pVista?.nombre ?? ''}`;
  const conFranjaTrabajo = hayPestanas || vista.ruta !== 'inicio';
  return (
    <NavegarContexto.Provider value={navegar}>
      <ProveedorAbrirDte abrir={abrirDteGlobal}>
        <div
          className={`shell erp-random${validacion ? ' con-franja' : ''}${conFranjaTrabajo ? ' con-trabajo' : ''}`}
        >
          {validacion && <FranjaValidacion salud={salud.data} />}
          <header className="barra-global">
            <button
              type="button"
              className="marca"
              onClick={() => navegar('inicio')}
              title="Inicio"
              aria-label="MADECI · Inicio"
            >
              MADECI
            </button>
            <MenuPrincipal
              subsistema={moduloSubsistema}
              nombresCortos={nombresCortos}
              favoritos={favoritos}
              alElegir={(p) => abrirPantalla(p)}
              alAlternarFavorito={alternarFavorito}
            />
            <span className="espaciador" />
            <button
              type="button"
              className="boton-lupa"
              onClick={() => setBuscar(true)}
              aria-label="Buscar (Ctrl+K)"
              title="Buscar o ejecutar un comando en todo el ERP (Ctrl+K)"
            >
              <Icono nombre="buscar" tamano={16} />
              <kbd aria-hidden>Ctrl+K</kbd>
            </button>
            {sesion.empresa && sesion.puede('ventas.nota.aprobar') && (
              <FirmasPendientes
                empresaId={sesion.empresa.id}
                alAbrir={() => abrirRuta('ventas/firmas')}
              />
            )}
            <AvisoConexion />
            <MenuUsuario alAyuda={() => setAyuda(true)} />
          </header>

          <BarraHerramientas
            modulos={modulos}
            subsistema={moduloSubsistema?.id ?? null}
            enInicio={!activa && vista.ruta === 'inicio'}
            nombresCortos={nombresCortos}
            favoritos={favoritos}
            visible={puedeVer}
            alInicio={() => navegar('inicio')}
            alElegirSubsistema={elegirSubsistema}
            alElegir={(p) => abrirPantalla(p)}
          />

          {conFranjaTrabajo && (
            <div className="barra-ventanas">
              {/* El área central (lo que se navegó): una sola, no es una pestaña. */}
              <button
                type="button"
                className={`vista-actual${activa ? '' : ' activa'}`}
                onClick={() => despachar({ tipo: 'navegar' })}
                aria-label={`Área principal: ${nombreVista}`}
                title="Volver a lo que estabas consultando"
              >
                {nombreVista}
              </button>
              {hayPestanas && (
                <div className="pestanas-trabajo" role="tablist" aria-label="Trabajo abierto">
                  {estado.pestanas.map((p, i) => (
                    <div key={p.id} className={`pestana ${p.id === estado.activa ? 'activa' : ''}`}>
                      <button
                        type="button"
                        role="tab"
                        aria-selected={p.id === estado.activa}
                        onClick={() => despachar({ tipo: 'activar', id: p.id })}
                        title={i < 9 ? `${p.titulo} (Alt+${i + 1})` : p.titulo}
                      >
                        {p.sucia && (
                          <span className="sucia" aria-label="con cambios sin guardar">
                            ●
                          </span>
                        )}
                        {p.titulo}
                      </button>
                      <button
                        type="button"
                        className="cerrar"
                        aria-label={`Cerrar ${p.titulo}`}
                        title="Cerrar (Alt+Q)"
                        onClick={() => pedirCierre(p)}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          <div className="area-trabajo">
            {!sesion.permisosCargados ? (
              <p className="apagado">Cargando permisos…</p>
            ) : (
              <>
                {vistas.map((v) => {
                  const visible = !activa && v.clave === vista.clave;
                  const p = pantallaPorRuta(v.ruta);
                  return (
                    <section
                      key={v.clave}
                      role="region"
                      aria-label={v.ruta === 'inicio' ? 'Inicio' : (p?.nombre ?? v.ruta)}
                      hidden={!visible}
                      className="contenido-pestana contenido-vista"
                      data-vista={v.clave}
                    >
                      <ContenidoVista
                        vista={v}
                        visible={visible}
                        abrir={abrir}
                        navegar={navegar}
                        abrirRuta={abrirRuta}
                        abrirContexto={abrirContexto}
                        abrirProducto={abrirProducto}
                      />
                    </section>
                  );
                })}
                {estado.pestanas.map((p) => (
                  <section
                    key={p.id}
                    role="tabpanel"
                    aria-label={p.titulo}
                    hidden={p.id !== estado.activa}
                    className={`contenido-pestana tipo-${p.tipo}`}
                  >
                    <ContenidoPestana pestana={p} activa={p.id === estado.activa} abrir={abrir} />
                  </section>
                ))}
              </>
            )}
          </div>

          <BarraEstado
            validacion={validacion}
            rotuloModo={
              modoInstancia === 'UAT'
                ? 'UAT'
                : esPreproduccion(salud.data)
                  ? 'PREPRODUCCIÓN'
                  : 'VALIDACIÓN'
            }
            alCambiarEmpresa={cambiarEmpresa}
          />

          {buscar && sesion.empresa && (
            <BuscadorGlobal alElegir={elegirResultado} alCerrar={() => setBuscar(false)} />
          )}
          {ayuda && (
            <Modal titulo="Atajos de teclado" alCerrar={() => setAyuda(false)} ancho="medio">
              <AyudaAtajos />
            </Modal>
          )}
          {cerrando && (
            <Modal
              titulo="Cerrar con cambios sin guardar"
              ancho="angosto"
              alCerrar={() => setCerrando(null)}
              pie={
                <>
                  <button type="button" onClick={() => setCerrando(null)}>
                    Volver
                  </button>
                  <button
                    type="button"
                    className="peligro"
                    data-autofoco
                    onClick={() => {
                      despachar({ tipo: 'cerrar', id: cerrando.id });
                      setCerrando(null);
                    }}
                  >
                    Cerrar y perder cambios
                  </button>
                </>
              }
            >
              <p>«{cerrando.titulo}» tiene cambios que no se guardaron. ¿Cerrar igual?</p>
            </Modal>
          )}
          {cambioEmpresa && (
            <Modal
              titulo="Cambiar de empresa"
              ancho="angosto"
              alCerrar={() => setCambioEmpresa(null)}
              pie={
                <>
                  <button type="button" onClick={() => setCambioEmpresa(null)}>
                    Volver
                  </button>
                  <button
                    type="button"
                    className="peligro"
                    data-autofoco
                    onClick={() => {
                      sesion.elegirEmpresa(cambioEmpresa);
                      setCambioEmpresa(null);
                    }}
                  >
                    Cambiar y cerrar todo
                  </button>
                </>
              }
            >
              <p>
                Hay ventanas con cambios sin guardar. Al cambiar de empresa se cierran todas las
                ventanas y se borra lo consultado de la empresa actual.
              </p>
            </Modal>
          )}
        </div>
      </ProveedorAbrirDte>
    </NavegarContexto.Provider>
  );
}

/** Lo que muestra la vista de navegación: Inicio, la portada de un módulo o una consulta. */
function ContenidoVista({
  vista: v,
  visible,
  abrir,
  navegar,
  abrirRuta,
  abrirContexto,
  abrirProducto,
}: {
  vista: Vista;
  visible: boolean;
  abrir: Abrir;
  navegar: Navegar;
  abrirRuta: (ruta: string, params?: Record<string, string>) => void;
  abrirContexto: (c: Pick<ClienteEncontrado, 'id' | 'razon_social'>) => void;
  abrirProducto: (p: { id: string; sku: string; nombre: string }) => void;
}) {
  const { puede } = useSesion();
  const abrirNota = (notaId: string, numero: string) => abrir('nota', { notaId }, numero);
  const abrirDte = (documentoId: string, titulo: string) => abrir('dte', { documentoId }, titulo);
  if (v.ruta === 'inicio')
    return (
      <Inicio abrir={abrir} navegar={navegar} abrirRuta={abrirRuta} abrirContexto={abrirContexto} />
    );
  const p = pantallaPorRuta(v.ruta);
  if (!p) return <PantallaPreparada ruta={v.ruta} />;
  switch (p.abre?.tipo) {
    case 'documentos-emitidos':
      return (
        <DocumentosEmitidos
          alAbrirDte={abrirDte}
          alAbrirNota={abrirNota}
          tipoInicial={v.params['tipo'] ?? p.abre.params?.['tipo']}
        />
      );
    case 'notas':
      return (
        <ConsultaDocumentos
          alAbrirNota={abrirNota}
          alAbrirDte={abrirDte}
          estadoInicial={v.params['estado'] ?? p.abre.params?.['estado']}
        />
      );
    case 'clientes':
      return <ConsultaClientes activa={visible} alAbrirCliente={abrirContexto} />;
    case 'productos':
      return (
        <ConsultaProductos
          activa={visible}
          textoInicial={v.params['texto'] ?? ''}
          alAbrirProducto={abrirProducto}
        />
      );
    case 'solicitudes':
      return <BandejaSolicitudes activa={visible} alAbrirCliente={abrirContexto} />;
    case 'mi-turno':
      return <MiTurno activa={visible} />;
    case 'turnos-caja':
      return <TurnosCaja activa={visible} />;
    case 'excepciones-caja':
      return <ExcepcionesCierre activa={visible} />;
    case 'operadores-caja':
      return <OperadoresCaja />;
    case 'mapa':
      return <MapaErp alAbrir={(r) => abrirRuta(r)} />;
    case 'stock-bodega':
      return <StockPorBodega alAbrirProducto={abrirProducto} />;
    case 'movimientos':
      return <Movimientos tipoInicial={v.params['tipo']} />;
    case 'kardex':
      return <Kardex />;
    case 'ajustes-stock':
      return <AjustesStock />;
    case 'inventario-fisico':
      return <InventarioFisico />;
    case 'valorizacion':
      return <Valorizacion />;
    case 'ordenes-despacho':
      return (
        <OrdenesDespacho
          estados={v.params['estados'] ?? p.abre.params?.['estados']}
          alAbrir={(o) => abrir('od', { odId: o.id }, `ODD ${o.numero}`)}
          alNueva={() => abrir('od')}
        />
      );
    case 'cheques':
      return <CarteraCheques />;
    case 'recepcion-rutas':
      return <RecepcionRutas />;
    case 'rendicion-odd':
      return (
        <RendicionOdd alHacerNc={(documento) => abrirRuta('ventas/nota-credito', { documento })} />
      );
    case 'caja-tesoreria':
      return <CajaTesoreria />;
    case 'cobros-ruta':
      return <CobrosRuta />;
    case 'cartola':
      return (
        <CartolaCliente
          clienteInicial={
            v.params['clienteId']
              ? { id: v.params['clienteId'], razonSocial: v.params['cliente'] ?? '' }
              : undefined
          }
          alCobrar={(c) =>
            abrir(
              'cobro',
              { modo: 'factura', clienteId: c.id, cliente: c.razonSocial },
              `Cobro · ${c.razonSocial}`,
            )
          }
        />
      );
    case 'cxc':
      return (
        <CxcResumen
          alAbrirCartola={(clienteId, cliente) => navegar('cobros/cartola', { clienteId, cliente })}
        />
      );
    case 'cartola-vendedor':
      return (
        <CartolaVendedor
          alAbrirCartola={(clienteId, cliente) => navegar('cobros/cartola', { clienteId, cliente })}
        />
      );
    case 'vencimientos':
      return <Vencimientos />;
    case 'historial-cobros':
      return (
        <TeneduriaPagos
          alAplicar={(c) =>
            abrir(
              'cobro',
              { modo: 'aplicacion', clienteId: c.id, cliente: c.razonSocial },
              `Aplicar saldo · ${c.razonSocial}`,
            )
          }
        />
      );
    case 'autorizaciones-pago':
      return <AutorizacionesPago />;
    case 'cuentas-bancarias':
      return <CuentasBancarias />;
    case 'cxp':
      return (
        <CxpResumen
          alAbrirCartola={(proveedorId, proveedor) =>
            navegar('pagos/cartola', { proveedorId, proveedor })
          }
        />
      );
    case 'cartola-proveedor':
      return (
        <CartolaProveedor
          proveedorInicial={
            v.params['proveedorId']
              ? { id: v.params['proveedorId'], razonSocial: v.params['proveedor'] ?? '' }
              : undefined
          }
        />
      );
    case 'historial-pagos':
      return <HistorialPagos />;
    case 'cotizaciones':
      return (
        <Cotizaciones
          alAbrir={(cotizacionId, t) => abrir('cotizacion', { cotizacionId }, t)}
          alNueva={() => abrir('cotizacion')}
        />
      );
    case 'pedidos':
      return <Pedidos alAbrirNota={abrirNota} />;
    case 'correcciones-venta':
      return <CorreccionesVenta seccionInicial={v.params['seccion']} />;
    case 'nc-directa':
      return <NotaCreditoDirecta documentoInicial={v.params['documento']} />;
    case 'consignaciones':
      return (
        <Consignaciones
          alFacturar={(clienteId, ubicacionId, nombre) =>
            abrir(
              'nota',
              { directo: 'FACTURA', clienteId, ubicacionId },
              `Consignación · ${nombre}`,
            )
          }
        />
      );
    case 'despachos-venta':
      return <DespachosVenta alAbrirNota={abrirNota} />;
    case 'transferencias':
      return <Transferencias />;
    case 'reservas':
      return <Reservas alAbrirNota={abrirNota} />;
    case 'impresion-masiva':
      return <ImpresionMasiva />;
    case 'vales':
      return <ConsultaVales alAbrirNota={abrirNota} />;
    case 'dte': {
      const modo = p.abre.params?.['modo'] ?? 'documentos';
      if (modo === 'monitor') return <MonitorDte />;
      if (modo === 'publicacion') return <PublicacionDte alAbrirNota={abrirNota} />;
      if (modo === 'folios') return <FoliosCaf />;
      return (
        <DocumentosDte
          modo={modo as 'documentos' | 'estado-sii' | 'reimpresion' | 'incidencias'}
          tipoInicial={p.abre.params?.['tipo']}
          alAbrirNota={abrirNota}
          alAbrirDte={abrirDte}
        />
      );
    }
    case 'incidencias-od':
      return <IncidenciasOd alAbrirOd={(odId, numero) => abrir('od', { odId }, `ODD ${numero}`)} />;
    case 'tratamiento-precios':
      return <TratamientoListas alAbrirProducto={abrirProducto} />;
    case 'config':
      return (
        <PantallaConfig maestro={p.abre.params?.['maestro'] ?? ''} foco={p.abre.params?.['foco']} />
      );
    case 'panel-negocio':
      return <PanelNegocio />;
    case 'informes':
      return <Informes modulo={p.abre.params?.['modulo'] ?? 'ventas'} />;
    case 'ordenes-compra':
      return (
        <OrdenesCompra
          estadoInicial={v.params['estado']}
          alAbrir={(id, t) => abrir('compra', { doc: 'oc', id }, t)}
          alNueva={() => abrir('compra', { doc: 'oc' })}
        />
      );
    case 'recepciones':
      return (
        <Recepciones
          alAbrir={(id, t) => abrir('compra', { doc: 'recepcion', id }, t)}
          alNuevaSinOc={() => abrir('compra', { doc: 'recepcion' })}
        />
      );
    case 'facturas-compra':
      return (
        <FacturasCompra
          alAbrir={(id, t) => abrir('compra', { doc: 'factura', id }, t)}
          alNueva={() => abrir('compra', { doc: 'factura' })}
        />
      );
    case 'registro-compras':
      return (
        <RegistroCompras
          alAbrirFactura={(id) => abrir('compra', { doc: 'factura', id }, 'Factura')}
          alAbrirRecibido={(id) => abrir('compra', { doc: 'recibido', id }, 'XML recibido')}
        />
      );
    case 'recibidos-compra':
      return <FacturasRecibidas alAbrir={(id, t) => abrir('compra', { doc: 'recibido', id }, t)} />;
    case 'notas-compra':
      return (
        <NotasCompra
          alAbrir={(id, t) => abrir('compra', { doc: 'nota', id }, t)}
          alNueva={() => abrir('compra', { doc: 'nota' })}
        />
      );
    case 'devoluciones-compra':
      return (
        <DevolucionesCompra alAbrir={(id, t) => abrir('compra', { doc: 'devolucion', id }, t)} />
      );
    case 'documentos-random':
      return <DocumentosRandom />;
    case 'documentos-guardados':
      return (
        <DocumentosGuardados
          ambito={
            v.params['ambito'] === 'compras' || v.params['ambito'] === 'ventas'
              ? v.params['ambito']
              : null
          }
          alAbrir={(tipo, params, titulo) => abrir(tipo, params, titulo)}
        />
      );
    case 'aprobaciones-ventas':
      // Firmas: las notas y, debajo, los cambios de ficha pedidos en línea (2026-10-24).
      return (
        <>
          <AprobacionesVentas alAbrirNota={abrirNota} />
          {/* 0122: lo que la caja pidió emitir sin pago, y su historial para tesorería. */}
          <FirmasSinPago alAbrirNota={abrirNota} />
          {puede('entidades.ficha.aprobar_cambio') && (
            <BandejaSolicitudes embebida activa={visible} alAbrirCliente={abrirContexto} />
          )}
        </>
      );
    case 'aprobaciones-compras':
      return (
        <AprobacionesCompras
          alAbrirOc={(id, t) => abrir('compra', { doc: 'oc', id }, t)}
          alAbrirRecepcion={(id, t) => abrir('compra', { doc: 'recepcion', id }, t)}
          alAbrirFactura={(id, t) => abrir('compra', { doc: 'factura', id }, t)}
          alAbrirDevolucion={(id, t) => abrir('compra', { doc: 'devolucion', id }, t)}
        />
      );
    case 'proveedores':
      return (
        <ProveedoresCompras
          alHistorial={(proveedorId, proveedor) =>
            navegar('compras/historial', { proveedorId, proveedor })
          }
          alFicha={(c) => abrir('compra', { doc: 'proveedor', id: c.id }, c.razon_social)}
        />
      );
    case 'costos-compra':
      return <CostosCompra />;
    case 'costos-logisticos':
      return <CostosLogisticos />;
    case 'esperando-nc':
      return <EsperandoNc alAbrirFactura={(id, t) => abrir('compra', { doc: 'factura', id }, t)} />;
    case 'historial-compras':
      return (
        <HistorialCompras
          proveedorInicial={
            v.params['proveedorId']
              ? { id: v.params['proveedorId'], razonSocial: v.params['proveedor'] ?? '' }
              : undefined
          }
          alAbrirOc={(id, t) => abrir('compra', { doc: 'oc', id }, t)}
          alAbrirRecepcion={(id, t) => abrir('compra', { doc: 'recepcion', id }, t)}
          alAbrirFactura={(id, t) => abrir('compra', { doc: 'factura', id }, t)}
          alAbrirNota={(id, t) => abrir('compra', { doc: 'nota', id }, t)}
          alAbrirDevolucion={(id, t) => abrir('compra', { doc: 'devolucion', id }, t)}
        />
      );
    case 'maestro-logistica':
      return (
        <MaestrosLogistica
          tipo={(p.abre.params?.['tipo'] ?? 'camiones') as 'camiones' | 'choferes' | 'rutas'}
        />
      );
    default:
      return <PantallaPreparada ruta={v.ruta} />;
  }
}

/** Lo que muestra una pestaña de trabajo: el objeto o proceso abierto. */
function ContenidoPestana({
  pestana: p,
  activa,
  abrir,
}: {
  pestana: Pestana;
  activa: boolean;
  abrir: Abrir;
}) {
  const { despachar } = usePestanas();
  const { puede } = useSesion();
  const titular = useCallback(
    (titulo: string, clave: string, params: Record<string, string>) =>
      despachar({ tipo: 'titular', id: p.id, titulo, clave, params }),
    [despachar, p.id],
  );
  const ensuciar = useCallback(
    (sucia: boolean) => despachar({ tipo: 'ensuciar', id: p.id, sucia }),
    [despachar, p.id],
  );
  const abrirNota = (notaId: string, numero: string) => abrir('nota', { notaId }, numero);
  // Terminada la nota, la MISMA pestaña parte una nueva (se vuelve a montar limpia, con otra clave).
  // Con `guardada`, la nota nueva avisa que la anterior quedó guardada como borrador.
  const nuevaEnEstaPestana = useCallback(
    (guardada?: { notaId: string; numero: string }) => {
      const gen = String(Date.now());
      despachar({
        tipo: 'titular',
        id: p.id,
        titulo:
          p.params['modo'] === 'meson'
            ? 'Punto de venta'
            : p.params['directo']
              ? (TITULO_DIRECTO[p.params['directo']] ?? 'Nota nueva')
              : 'Nota nueva',
        clave: `nota:nueva:${gen}`,
        params: {
          notaId: '',
          clienteId: '',
          gen,
          guardadaId: guardada?.notaId ?? '',
          guardadaNumero: guardada?.numero ?? '',
        },
      });
    },
    [despachar, p.id, p.params],
  );
  switch (p.tipo) {
    case 'nota':
      return (
        <NotaVenta
          key={p.params['gen'] ?? 'g0'}
          activa={activa}
          alNuevaNota={nuevaEnEstaPestana}
          alTomarNota={(notaId, numero, deGuardados) =>
            despachar({
              tipo: 'titular',
              id: p.id,
              titulo: numero,
              clave: `nota:${notaId}`,
              params: {
                notaId,
                clienteId: '',
                gen: String(Date.now()),
                guardadaId: '',
                guardadaNumero: '',
                tomada: deGuardados ? '1' : '',
              },
            })
          }
          {...(p.params['guardadaId']
            ? {
                guardadaRecien: {
                  notaId: p.params['guardadaId'],
                  numero: p.params['guardadaNumero'] ?? '',
                },
              }
            : {})}
          meson={p.params['modo'] === 'meson'}
          tomadaDeGuardados={p.params['tomada'] === '1'}
          {...(p.params['directo'] && TITULO_DIRECTO[p.params['directo']]
            ? { directo: p.params['directo'] as 'FACTURA' | 'BOLETA' | 'GUIA' }
            : {})}
          {...(p.params['notaId'] ? { notaId: p.params['notaId'] } : {})}
          {...(p.params['clienteId'] ? { clienteInicialId: p.params['clienteId'] } : {})}
          {...(p.params['ubicacionId'] ? { ubicacionInicialId: p.params['ubicacionId'] } : {})}
          alTitular={titular}
          alEnsuciar={ensuciar}
          alAbrirNota={abrirNota}
          alAbrirFicha={(entidadId, nombre) => abrir('cliente', { entidadId }, nombre)}
          alAbrirDte={(documentoId, titulo) => abrir('dte', { documentoId }, titulo)}
          {...(puede('ventas.despacho.crear') || puede('ventas.despacho.confirmar')
            ? {
                alAbrirDespacho: (notaId: string, numero: string) =>
                  abrir('despacho', { notaId }, `Despacho ${numero}`),
              }
            : {})}
        />
      );
    // Ficha Comercial 360: UNA sola, se llegue por Clientes, por Ctrl+K o por un enlace.
    case 'contexto':
    case 'cliente':
      return (
        <ContextoCliente
          activa={activa}
          entidadId={p.params['entidadId']!}
          alAbrirNota={abrirNota}
          alNuevaNota={(c) => abrir('nota', { clienteId: c.id }, `Nota nueva · ${c.razonSocial}`)}
        />
      );
    case 'producto':
      return <FichaProducto productoId={p.params['productoId']!} />;
    case 'despacho':
      return <Despacho notaId={p.params['notaId']!} activa={activa} />;
    case 'pago':
      return (
        <PagoProveedor
          modo={(p.params['modo'] ?? 'factura') as ModoPago}
          proveedorInicial={
            p.params['proveedorId']
              ? { id: p.params['proveedorId'], razonSocial: p.params['proveedor'] ?? '' }
              : undefined
          }
        />
      );
    case 'cobro':
      return (
        <Cobro
          modo={(p.params['modo'] ?? 'factura') as ModoCobro}
          clienteInicial={
            p.params['clienteId']
              ? { id: p.params['clienteId'], razonSocial: p.params['cliente'] ?? '' }
              : undefined
          }
        />
      );
    case 'cotizacion':
      return (
        <Cotizacion
          cotizacionId={p.params['cotizacionId'] || undefined}
          alCreada={(cotizacionId, numero) =>
            titular(numero, `cot:${cotizacionId}`, { cotizacionId })
          }
          alAbrirNota={abrirNota}
        />
      );
    case 'compra':
      return (
        <PestanaCompra
          params={p.params}
          abrirCompra={(params, titulo) => abrir('compra', params, titulo)}
          titular={titular}
          alPagar={(x) =>
            abrir(
              'pago',
              { modo: 'documentos', proveedorId: x.id, proveedor: x.razonSocial },
              `Pagar · ${x.razonSocial}`,
            )
          }
        />
      );
    case 'dte':
      return (
        <FichaDte
          documentoId={p.params['documentoId']!}
          alAbrirDte={(documentoId, titulo) => abrir('dte', { documentoId }, titulo)}
          alAbrirNota={abrirNota}
          alTitular={(titulo) => titular(titulo, p.clave, p.params)}
        />
      );
    case 'od':
      return (
        <OrdenDespacho
          odId={p.params['odId']}
          alCreada={(odId, numero) => titular(`ODD ${numero}`, `od:${odId}`, { odId })}
          alAbrirNota={abrirNota}
        />
      );
  }
}

/** Inicio: el área central tranquila (logo, pendientes, recientes). */
function Inicio({
  abrir,
  navegar,
  abrirRuta,
  abrirContexto,
}: {
  abrir: Abrir;
  navegar: Navegar;
  abrirRuta: (ruta: string) => void;
  abrirContexto: (c: Pick<ClienteEncontrado, 'id' | 'razon_social'>) => void;
}) {
  const { usuario, empresa } = useSesion();
  const { recientes } = useRecientes(usuario?.id, empresa?.id);
  return (
    <CentroOperativo
      abrirRuta={abrirRuta}
      abrirNotas={(estado) => navegar('ventas/notas', { estado })}
      recientes={recientes}
      alAbrirReciente={(r: Reciente) =>
        r.tipo === 'nota'
          ? abrir('nota', { notaId: r.id }, r.titulo)
          : r.tipo === 'producto'
            ? abrir('producto', { productoId: r.id }, r.titulo)
            : abrirContexto({ id: r.id, razon_social: r.titulo })
      }
    />
  );
}
